import { getErrorMessage } from "@timeedit/registration-shared";
import "./errorInfo.scss";
import { Button, Typography } from "@timeedit/ui-components";
import { ErrorLogId } from "../ErrorLogId";
import ErrorIcon from "@timeedit/ui-components/icons/Error";
import { TitleProps } from "@timeedit/ui-components/antd/typography/Title";

interface Translations {
  retry: string;
  title: string;
}

interface ErrorInfoProps {
  translations: Translations;
  error: unknown;
  /** Shown in place of the error's own message, which may be technical. */
  description?: string;
  recover: () => void;
  semanticTitleLevel: TitleProps["level"];
  loading?: boolean;
}

export function ErrorInfo({
  translations,
  error,
  description,
  recover,
  semanticTitleLevel,
  loading,
}: ErrorInfoProps): React.JSX.Element {
  const message = description ?? getErrorMessage(error);
  const newLineText = message.split("\n").map((str, index) => (
    <Typography.Text type="secondary" key={index}>
      {str}
    </Typography.Text>
  ));

  return (
    <div role="alert" className="error-info__container">
      <div className="error-info-icon__container">
        <ErrorIcon aria-hidden size={72} />
      </div>
      <Typography.Title level={3} semanticLevel={semanticTitleLevel}>
        {translations.title}
      </Typography.Title>
      {newLineText}
      <br />
      <ErrorLogId error={error} />
      <Button
        type="primary"
        onClick={recover}
        data-testid="retry-button"
        loading={loading}
      >
        {translations.retry}
      </Button>
    </div>
  );
}
